import {Business, CardTransaction, CurrentUser, MenuSection} from "../../../types/Types";
import {Form} from "react-bootstrap";
import * as React from "react";
import {useState} from "react";
import {useNavigate, useParams} from "react-router";
import TextField from "../../../components/form/TextField";
import LocationSelector from "../../../components/form/LocationSelector";
import NumberField from "../../../components/form/NumberField";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSort} from "@fortawesome/free-solid-svg-icons";
import {useEffect} from "react";
import {collection, getDocs, limit, orderBy, query, where} from "@firebase/firestore";
import {db, functions} from "../../../firebase/FirebaseProvider";
import {httpsCallable} from "@firebase/functions";

interface Props {
  currentUser: CurrentUser,
  business: Business | undefined,
}

function MenuSectionUpdatePage(props: Props) {
  const navigate = useNavigate();
  const [updating, setUpdating] = useState<boolean>(false);

  const [menuSection, setMenuSection] = useState<MenuSection>();

  const [location, setLocation] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [order, setOrder] = useState<number>();

  const { sectionId: menuSectionId } = useParams();

  const updateMenuSection = async () => {
    if(!props.business) {
      return
    }
    setUpdating(true);

    const updateMenuSection = httpsCallable(functions, 'updateMenuSection');
    await updateMenuSection({
      business: props.business.id,
      location: location,
      menuSectionId: menuSectionId,
      description: description,
      order: order,
    }).then(() => {
      navigate("/menu");
    });
  };

  useEffect(() => {(async () => {
    const menuSectionsCollection = query(
        collection(db, 'menu-sections'),
        where("id", "==", menuSectionId),
        orderBy("createdAt", "desc"),
        limit(1),
    );
    const menuSectionsSnapshot = await getDocs(menuSectionsCollection);
    menuSectionsSnapshot.forEach((doc) => {
      const menuSectionToSet = doc.data() as MenuSection;
      setMenuSection(menuSectionToSet);
      setDescription(menuSectionToSet.description);
      setOrder(menuSectionToSet.order);
    });
  })();
  }, []);

  return (
      <div>
        <Form className={"mb-3"}>
          <LocationSelector business={props.business} setValue={setLocation}/>
          <TextField label={"Description"} subLabel={"For example: Drinks"} value={description} setValue={setDescription} required={true}/>
          <NumberField label={"Order"} subLabel={"The sections's position in the menu."} unit={<FontAwesomeIcon icon={faSort}/>} placeholder={""} step={1} value={order} setValue={setOrder} required={true}/>
        </Form>
        {!updating && <div className={"primary-button"} onClick={() => updateMenuSection()}>Update Menu Section</div>}
        {updating && <div className={"primary-button"}>Updating...</div>}
      </div>
  );
}

export default MenuSectionUpdatePage;